import { useSyncExternalStore } from 'react';

export function useIsClient() {
  return useSyncExternalStore(
    () => () => {
      // No-op unsubscribe function
    },
    () => true,
    () => false
  );
}
